import React from "react";
import { Link } from "react-router-dom";

/**
 * Card cupón vintage perforado — pilar del Home (Descubre/Recorre/Canjea).
 * Fondo Mostaza (#FEBA01) + perforaciones laterales + dashed "corta aquí".
 *
 * Si recibe la prop `to`, se renderiza como `<Link>` de React Router y es clickeable.
 * Si no, se renderiza como `<div>` estático.
 */
export default function Pillar({ icon, title, desc, testid, to }) {
  const commonClasses =
    "relative overflow-hidden group p-5 bg-[#FEBA01] text-black rounded-2xl transition-all duration-300 hover:-translate-y-1 block focus:outline-none focus:ring-2 focus:ring-black/40";
  const commonStyle = {
    boxShadow: "6px 6px 0 0 rgba(0,0,0,0.85), inset 0 0 0 1px rgba(0,0,0,0.08)",
    backgroundImage:
      "radial-gradient(circle at 20% 15%, rgba(255,255,255,0.18), transparent 45%), radial-gradient(circle at 85% 85%, rgba(0,0,0,0.06), transparent 55%)",
  };

  const content = (
    <>
      {/* Perforaciones laterales */}
      <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-5 flex flex-col justify-around items-center py-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="w-2 h-2 rounded-full bg-black/90" />
        ))}
      </div>
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-5 flex flex-col justify-around items-center py-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="w-2 h-2 rounded-full bg-black/90" />
        ))}
      </div>

      {/* Línea dashed "corta aquí" a la izquierda */}
      <div className="pointer-events-none absolute top-4 bottom-4 left-7 w-0 border-l-2 border-dashed border-black/25" />

      <div className="relative ml-6 mr-5">
        <div
          className="text-black transition-transform duration-300 group-hover:scale-110 flex items-center justify-center"
          style={{ width: 72, height: 72 }}
        >
          {icon}
        </div>

        <div className="mt-3 flex items-center gap-3">
          <h3 className="font-display text-2xl uppercase tracking-tight text-black leading-none">{title}</h3>
          <span className="h-0.5 flex-1 bg-black/30" />
        </div>
        <p className="mt-2 text-xs leading-relaxed text-black/80 font-medium">{desc}</p>
      </div>
    </>
  );

  if (to) {
    return (
      <Link to={to} data-testid={testid} className={commonClasses} style={commonStyle}>
        {content}
      </Link>
    );
  }

  return (
    <div data-testid={testid} className={commonClasses} style={commonStyle}>
      {content}
    </div>
  );
}
